import request from '@/libs/request'

//采摘销售 列表
export function plantSaleListApi (data) {
  return request({
    url: `plant/plantSale`,
    method: 'get',
    params: data
  })
}

//采摘销售 详情
export function plantSaleInfoApi (id) {
  return request({
    url: `plant/plantSale/` + id,
    method: 'get'
  })
}


//采摘销售 编辑/添加
export function plantSaleSaveApi (data) {
  return request({
    url: `plant/plantSale`,
    method: 'post',
    data: data
  })
}

//采摘销售 删除
export function plantSaleDelApi (id) {
  return request({
    url: `plant/plantSale/` + id,
    method: 'delete'
  })
}

